import { ProcessedHistory } from '../../ContactDrawer';
import { AudioModal, TranscriptModal } from 'components';
import { CallInfo } from 'types/agentCommandCenter.type';
import { useMemo, useState } from 'react';

import styles from '../../ContactManager.module.scss';
import { SMSItem } from './SMSItem';
import { CallItem } from './CallItem';

export const TabDetails = ({
    contactHistory,
    contactName = '',
}: {
    contactHistory: ProcessedHistory[];
    contactName?: string;
}) => {
    const [showTranscriptModal, setShowTranscriptModal] = useState(false);
    const [showAudioModal, setShowAudioModal] = useState(false);

    const [currentCallId, setCurrentCallId] = useState<string | null>(null);
    const [currentCallInfo, setCurrentCallInfo] = useState<CallInfo | undefined>(undefined);

    const callIds = useMemo(
        () =>
            contactHistory
                .filter((item): item is Extract<ProcessedHistory, { type: 'call' }> => item.type === 'call')
                .map((historyItem) => historyItem.id),
        [contactHistory]
    );

    const onViewTranscript = (callId: string, callInfo: CallInfo) => {
        setShowTranscriptModal(true);
        setCurrentCallId(callId);
        setCurrentCallInfo(callInfo);
    };

    const onListenRecording = (callId: string, callInfo: CallInfo) => {
        setShowAudioModal(true);
        setCurrentCallId(callId);
        setCurrentCallInfo(callInfo);
    };

    return (
        <div className={styles.callsSection}>
            <h3>Contact History</h3>

            {contactHistory.length > 0 ? (
                <div className={styles.callsTimeline}>
                    {contactHistory.map((historyItem) => {
                        if (historyItem.type === 'sms') {
                            return <SMSItem key={historyItem.id} {...historyItem} />;
                        }
                        if (historyItem.type === 'call') {
                            return (
                                <CallItem
                                    key={historyItem.id}
                                    {...historyItem}
                                    onViewTranscript={onViewTranscript}
                                    onListenRecording={onListenRecording}
                                    callIds={callIds}
                                    contactName={contactName}
                                />
                            );
                        }
                    })}
                </div>
            ) : (
                <p className={styles.noCallsMessage}>No call history available for this contact.</p>
            )}

            <TranscriptModal
                isOpen={showTranscriptModal}
                onClose={() => {
                    setShowTranscriptModal(false);
                    setCurrentCallId(null);
                    setCurrentCallInfo(undefined);
                }}
                callId={currentCallId}
                callInfo={currentCallInfo}
            />

            <AudioModal
                isOpen={showAudioModal}
                onClose={() => {
                    setShowAudioModal(false);
                    setCurrentCallId(null);
                    setCurrentCallInfo(undefined);
                }}
                callId={currentCallId}
                callInfo={currentCallInfo}
            />
        </div>
    );
};
